// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2nwPW","field":"styles_field__913c1","fieldCol":"styles_fieldCol__1hArE","diffCol":"styles_diffCol__1Fh0H","diff":"styles_diff__3LFDj"};